declare global {
  interface Window {
    // Add any custom window properties here
  }
}

export const getThemeFromURL = (): string => {
  const url = new URL(window.location.href);
  const theme = url.searchParams.get('theme');
  return theme || 'light';
};

export const applyTheme = (theme: string): void => {
  if (theme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
};

export const getQueryParams = (): Record<string, string> => {
  const url = new URL(window.location.href);
  const params: Record<string, string> = {};
  
  url.searchParams.forEach((value, key) => {
    params[key] = value;
  });
  
  return params;
};

export const buildQueryURL = (params: Record<string, string>): string => {
  const url = new URL(window.location.href);
  
  Object.keys(params).forEach(key => {
    if (params[key]) {
      url.searchParams.set(key, params[key]);
    } else {
      url.searchParams.delete(key);
    }
  });
  
  return url.toString();
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy: ', err);
    return false;
  }
}; 